module.exports = __webpack_public_path__ + "static/media/liebherr350.ec75bfed.pdf";